import { createRoot } from 'react-dom/client'
import App from './App'

import { branch, PRODUCTION_HOST, STAGING_HOST } from './config'

const isProd = process.env.NODE_ENV === 'production'
const isBranchBuild = !(branch == null || branch === '')
const hostname = window.location.hostname

const allowlist = [PRODUCTION_HOST, STAGING_HOST]

// Skip canonical redirect on Heroku review apps when branch isn’t in the bundle (see docs/runtime-env-contract.md).
const isHerokuAppHost = hostname.endsWith('.herokuapp.com')

// Never redirect a local build (e.g. `yarn preview` of a production bundle) to prod.
const isLocalhost =
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]'

const needsRedirect =
  isProd &&
  !isBranchBuild &&
  !allowlist.includes(hostname) &&
  !isHerokuAppHost &&
  !isLocalhost

if (needsRedirect) {
  const isStaging = hostname.includes('staging')
  const redirectUrl = isStaging
    ? `https://${STAGING_HOST}`
    : `https://${PRODUCTION_HOST}`

  window.location.replace(
    redirectUrl + window.location.pathname + window.location.search,
  )
} else {
  const rootEl = document.getElementById('root')
  createRoot(rootEl).render(<App />)
}
